import api from './api';

const dashboardService = {
  // Get dashboard statistics
  getDashboardStats: async () => {
    const response = await api.get('/dashboard/stats');
    return response.data;
  },

  // Get project statistics
  getProjectStats: async () => {
    const response = await api.get('/dashboard/project-stats');
    return response.data;
  },

  // Get task statistics
  getTaskStats: async () => {
    const response = await api.get('/dashboard/task-stats');
    return response.data;
  },

  // Get time tracking statistics
  getTimeStats: async () => {
    const response = await api.get('/dashboard/time-stats');
    return response.data;
  },

  // Get recent activities
  getRecentActivities: async (limit = 10) => {
    const response = await api.get('/dashboard/activities', { params: { limit } });
    return response.data;
  },

  // Get executive dashboard data
  getExecutiveDashboard: async () => {
    const response = await api.get('/dashboard/executive');
    return response.data;
  },

  // Get project dashboard data
  getProjectDashboard: async (projectId = null) => {
    const params = projectId ? { projectId } : {};
    const response = await api.get('/dashboard/projects', { params });
    return response.data;
  },

  // Get team dashboard data
  getTeamDashboard: async () => {
    const response = await api.get('/dashboard/team');
    return response.data;
  },

  // Get financial dashboard data
  getFinancialDashboard: async () => {
    const response = await api.get('/dashboard/financial');
    return response.data;
  },

  createTeamMemberByAdmin: async (userData) => {
    const response = await api.post('/auth/createTeamMemberByAdmin',userData);
    return response.data;
  },

    updateTeamMember: async (memberId, userData) => {
    const response = await api.put(`/auth/team-members/${memberId}`, userData);
    return response.data;
  },
  deleteTeamMember: async (memberId) => {
    const response = await api.delete(`/auth/team-members/${memberId}`);
    return response.data;
  }
};

export default dashboardService;

